import { useEffect, useState } from 'react'
import {
  fromDoorstepInjectedEnvironment,
  isProduction,
} from '../utilities/environment'

enum VGS_VAULT_ENV {
  PRODUCTION = 'live',
  SANDBOX = 'sandbox',
}

enum VGS_VAULT_ID {
  PRODUCTION = 'tnt6lmmk3ml',
  SANDBOX = 'tntcmtf4wpl',
}

enum VGS_VAULT_CNAME {
  PRODUCTION = 'vgs.doordash.com',
  SANDBOX = 'vgs.doorcrawl.com',
}

const isProd = isProduction(fromDoorstepInjectedEnvironment(window))

export const getVGSVaultEnv = () => {
  return isProd ? VGS_VAULT_ENV.PRODUCTION : VGS_VAULT_ENV.SANDBOX
}

export const getVGSVaultId = () => {
  return isProd ? VGS_VAULT_ID.PRODUCTION : VGS_VAULT_ID.SANDBOX
}

export const getVGSVaultCname = () => {
  return isProd ? VGS_VAULT_CNAME.PRODUCTION : VGS_VAULT_CNAME.SANDBOX
}

export type VGSForm = {
  submit?: (path, opts, response, error) => void
  field?: (name, opts) => VGSField
  useCname?: (path) => void
}

export type VGSField = {
  mask?: (pattern: string) => void
}

export type VGSTypes = 'live' | 'sandbox'

export const VGS_VERSION = '2.10.0'

export const useVgs = () => {
  const [isLoaded, setIsLoaded] = useState(false)
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://js.verygoodvault.com/vgs-collect/2.9/vgs-collect.js'
    script.async = true
    script.onload = () => setIsLoaded(true)
    document.body.appendChild(script)
  })

  return isLoaded
}

export const useVgsForm = (isLoaded, onStateChange) => {
  const [form, setForm] = useState(null)

  useEffect(() => {
    if (isLoaded) {
      setForm(
        window.VGSCollect.create(getVGSVaultId(), getVGSVaultEnv(), state =>
          onStateChange(state)
        )
      )
    }
  }, [isLoaded, onStateChange])

  return form as VGSForm
}

export const setFormCname = (form: VGSForm) => {
  form.useCname(getVGSVaultCname())
}
